import * as React from 'react';
import * as styles from './LabelsBox.css';

export const LabelsBox: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['labels']}>{children}</div>;
};
